export { AcertaLogo } from './acerta-logo';
